import type { PasswordValidationStatus } from 'firebase/auth'
import clsx from 'clsx'
import { CheckCircleFilled, CheckCircleUnchecked } from '@/assets/icons'

export function PasswordRequirements({ status }: { status: PasswordValidationStatus | null }) {
  const requirements = [
    { label: 'At least 8 characters', met: status?.meetsMinPasswordLength },
    { label: 'Both uppercase and lowercase letters', met: status?.containsUppercaseLetter && status?.containsLowercaseLetter },
    { label: 'At least one number', met: status?.containsNumericCharacter },
    { label: 'At least one special character', met: status?.containsNonAlphanumericCharacter },
  ]

  return (
    <div id="password-requirements" className="flex flex-col gap-2 text-sm leading-5">
      <p className="font-medium text-brand-neutral-950">Password requirements:</p>
      <ul className="flex flex-col gap-2" aria-live="polite">
        {requirements.map(({ label, met }) => (
          <li key={label} className={clsx('flex items-start gap-1.5', met ? 'text-green-800' : 'text-brand-neutral-600')}>
            {met ? (
              <CheckCircleFilled aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
            ) : (
              <CheckCircleUnchecked aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
            )}
            <span className="sr-only">{met ? 'Met: ' : 'Not met: '}</span>
            {label}
          </li>
        ))}
      </ul>
    </div>
  )
}
